import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=2a88dfaf&scoped=true"
import script from "./AddSchool.vue?vue&type=script&lang=js"
export * from "./AddSchool.vue?vue&type=script&lang=js"
import style0 from "./AddSchool.vue?vue&type=style&index=0&id=2a88dfaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88dfaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
